import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import "./CollapseSearchField.css";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";

const CollapseSearchField = ({
    searchText,
    setSearchText,
}) => {
    const [isSearchVisible, setIsSearchVisible] = useState(true);
    const toggleSearchVisibility = () => {
        setIsSearchVisible((prev) => !prev);
    };
    return (
        <div className={`search-container`}>
            <FormControl
                variant="outlined"
                className={`search-input-wrapper ${isSearchVisible ? "search-input-wrapper--expanded" : "search-input-wrapper--collapsed"
                    }`}
            >
                <Input
                    id="category-search-input"
                    placeholder="Search"
                    value={searchText}
                    className={`white-rounded-input ${!isSearchVisible && "p-0"} `}
                    onChange={(e) => setSearchText(e.target.value)}
                    disableUnderline
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon onClick={toggleSearchVisibility} style={{ cursor: "pointer" }} />
                        </InputAdornment>
                    }
                />
            </FormControl>

            {!isSearchVisible && (
                <SearchIcon
                    className="search-toggle-icon white-rounded-search"
                    onClick={toggleSearchVisibility}
                />
            )}
        </div>
    );
}

export default CollapseSearchField;